import Vue from 'vue';
import VueRouter from 'vue-router';

import List from './components/List.vue';
import Login from './components/Login.vue';
import Guest from './components/Guest.vue';
import mGuest from './components/MGuest.vue';
import View from './components/View.vue';
import mView from './components/MView.vue';

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        { path: '*', redirect: '/guest' },
        { path: '/guest', name: 'guest', component: Guest, },
        { path: '/view', name: 'view', component: View, },
        { path: '/mguest', name: 'mguest', component: mGuest, },
        { path: '/mview', name: 'mview', component: mView, },
        { path: '/login', name: 'login', component: Login, },
        { path: '/list', name: 'list', component: List, },
    ],
    mode: 'history'
});

/*
router.beforeEach((to, from, next) => {
    var requiresAuth = to.matched.some(record => record.meta.requireAuth)
    if (requiresAuth) {
        next();
    } else {
        next();
    }
});
*/
/*
router.afterEach((to, from) => {
    if(from.name == 'guest'){
        if(ismobilejs.phone){
            to = ''
        }
    }
  });
  */
/*
router.beforeEach((to, from, next) => {
    var requiresAuth = to.matched.some(record => record.meta.requireAuth)
    if (requiresAuth) {
        next();
    } else {
        next();
    }

    this.$nextTick(() => {
        this.console.log(from);
    });
});
*/
export default router